module.exports = __webpack_public_path__ + "static/media/dram-glass.c36f75f2.png";